import { Eye, EyeOff } from 'lucide-react';

import { useAgentRefs } from '@/app/agentConversation/_context';
import { describeContext } from '@/app/agentConversation/_helpers';
import { cn } from '@/helpers/shadcn';

import { Button } from '@/app/ui/button';

/**
 * What the next message will be about: the record open on this page. A click
 * leaves the context out of the next message; it comes back after sending, or
 * on another page.
 */
const ContextChip = ({ context, isIncluded, onToggle }) => {
  const refs = useAgentRefs();
  const label = describeContext(context, refs);
  if (!label) return null;

  const Icon = isIncluded ? Eye : EyeOff;

  return (
    <Button
      variant="ghost"
      size="xs"
      onClick={onToggle}
      title={isIncluded ? 'Leave this out of the next message' : 'Include this in the next message'}
      className={cn('text-muted-foreground max-w-full justify-start font-normal', !isIncluded && 'line-through')}
      data-testid="agent-context-chip"
      data-included={isIncluded}
    >
      <Icon />
      <span className="truncate">On: {label}</span>
    </Button>
  );
};

export default ContextChip;
